import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProductosPorSearchInputService } from '../../../services/Buscador';
import { Container, Row, Col } from 'react-bootstrap';
import ProductosFiltradosContent from './ProductosFiltradosContent';
import { useGetCategorias } from '../../../utilities/hooks/Categorias/useGetCategorias';
import { authContext } from '../../Context/AuthContext';
import FiltroMarcasDinamicas from './FiltroMarcasDinamicas';

const ProductosFiltrados = () => {
    const { query } = useParams();
    const navigate = useNavigate();
    const { token } = useContext(authContext); // ✅ MANTENER PARA TOKEN
    const [productos, setProductos] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const productosPorPagina = 7;

    const { categorias: categoriasData } = useGetCategorias();

    const [marcasFiltro, setMarcasFiltro] = useState([]); // ✅ NUEVO: Para filtros de marca
    const [marcaSeleccionada, setMarcaSeleccionada] = useState(null); // ✅ NUEVO: Marca actualmente filtrada

    useEffect(() => {
        const fetchProductosFiltrados = async () => {
            setLoading(true);
            try {
                // ✅ RECIBIR OBJETO COMPLETO DEL SERVICIO
                const responseData = await getProductosPorSearchInputService(query);
                
                const productosFiltrados = responseData.articulos || [];

                console.log('✅ Productos extraídos:', productosFiltrados.length);

                // Combinar productos filtrados con productos encontrados por SKU
                const productosUnicos = [
                    ...productosFiltrados,
                ].reduce((acc, producto) => {
                    if (!acc.find(p => p.Alias === producto.Alias)) acc.push(producto);
                    return acc;
                }, []);

                const marcasUnicas = [...new Set(productosUnicos.map(p => p.Marca))].filter(Boolean);
                const marcasConCount = marcasUnicas.map(marca => ({
                    Descripcion: marca,
                    Codigo: marca.replace(/\s+/g, '-').toLowerCase(),
                    count: productosUnicos.filter(p => p.Marca === marca).length
                }));
                
                setMarcasFiltro(marcasConCount);

                const productosFiltradosPorMarca = marcaSeleccionada 
                    ? productosUnicos.filter(p => p.Marca === marcaSeleccionada)
                    : productosUnicos;

                setProductos(productosFiltradosPorMarca);

                const totalProductos = productosFiltradosPorMarca.length;
                setTotalPages(Math.ceil(totalProductos / productosPorPagina));

                const categoriasCoincidentes = categoriasData.filter(categoria =>
                    categoria.Descripcion.toLowerCase().includes(query.toLowerCase())
                );
                setCategorias(categoriasCoincidentes);
            } catch (error) {
                console.error('❌ ProductosFiltrados - Error:', error);
                setError('No se pudieron obtener los productos.');
            } finally {
                setLoading(false);
            }
        };

        fetchProductosFiltrados();
    }, [query, categoriasData, marcaSeleccionada]); // ✅ AGREGAR marcaSeleccionada a dependencias

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // ✅ FUNCIÓN PARA MANEJAR SELECCIÓN DE MARCA
    const handleMarcaSelect = (marca) => {
        setMarcaSeleccionada(marca === marcaSeleccionada ? null : marca); // Toggle
        setCurrentPage(1); // Reset a primera página
    };

    // ✅ ACTUALIZAR shouldShowFilters (quitar marcas viejas)
    const shouldShowFilters = categorias.length > 0 || marcasFiltro.length > 0;

    return (
        <>
            <img src={process.env.PUBLIC_URL + "/banner/BUSQUEDA2.png"} alt="Imagen capacitaciones" className='imagenesBody' loading='lazy' />
            <Container style={{ backgroundColor: 'white', marginTop: '1em' }}>
                <Row>
                    {shouldShowFilters ? (
                        <>
                            <Col md={3}>
                                <FiltroMarcasDinamicas 
                                    marcas={marcasFiltro} 
                                    marcaSeleccionada={marcaSeleccionada}
                                    onMarcaSelect={handleMarcaSelect}
                                    query={query} 
                                />
                            </Col>
                            <Col md={9}>
                                <ProductosFiltradosContent
                                    productos={productos.slice((currentPage - 1) * productosPorPagina, currentPage * productosPorPagina)}
                                    loading={loading}
                                    error={error}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    handlePageChange={handlePageChange}
                                    handleCardClick={(sku) => navigate(`/detalle?sku=${sku}`)}
                                />
                            </Col>
                        </>
                    ) : (
                        <Col md={12}>
                            <ProductosFiltradosContent
                                productos={productos.slice((currentPage - 1) * productosPorPagina, currentPage * productosPorPagina)}
                                loading={loading}
                                error={error}
                                currentPage={currentPage}
                                totalPages={totalPages}
                                handlePageChange={handlePageChange}
                                handleCardClick={(sku) => navigate(`/detalle?sku=${sku}`)}
                            />
                        </Col>
                    )}
                </Row>
            </Container>
        </>
    );
};

export default ProductosFiltrados;
